import React from 'react';
import PropTypes from 'prop-types';
import Carousel from 'react-material-ui-carousel';
import Grid from '@material-ui/core/Grid';

import StepCard from '../carouselCards/stepsCard';
import FeedbackCard from '../carouselCards/feedbackCard';
import Container from '../Container';

import FeedbackData from '../../constants/FeedbackCarousel';
import defaultStepCarouselData from '../../constants/StepCarousel';
import { StepCarouselData } from '../../types';

export interface CarouselLayoutProps {
  feedback?: boolean;
  stepCarouselData?: StepCarouselData;
  mainHeading?: string;
}

const CarouselLayout = ({
  feedback,
  stepCarouselData,
  mainHeading,
}: CarouselLayoutProps) => {
  return (
    <div className="carousel-layout" id={feedback ? '' : 'steps-carousel'}>
      <Container>
        {feedback ? (
          mainHeading? 
          <h3 className="global-heading medium-font">{mainHeading}</h3>
          :
          <h3 className="global-heading medium-font">
            <q className="quote-text">The best screen recorder for PC</q>
            <br />
            That’s what our customers say
          </h3>
        ) : (
          <h2 className="global-heading large-font">
            {mainHeading || 'How to record the screen on your PC'}
          </h2>
        )}
        <Carousel
          animation="slide"
          indicatorIconButtonProps={{
            className: '',
            style: {
              color: '#fff',
              backgroundColor: '#DD2F4D',
              margin: '0 5px',
              transform: 'scale(0.8)',
            },
          }}
          activeIndicatorIconButtonProps={{
            className: '',
            style: {
              color: '#DD2F4D',
            },
          }}
        >
          {(feedback ? FeedbackData : defaultStepCarouselData).map((slide) => {
            return (
              <Grid container className="grid-container">
                {slide.slideData.map((card) => {
                  return (
                    <Grid item md={4} xs={12}>
                      {feedback ? (
                        <FeedbackCard text={card.text} />
                      ) : (
                        <StepCard cardData={card} />
                      )}
                    </Grid>
                  );
                })}
              </Grid>
            );
          })}
        </Carousel>
      </Container>
    </div>
  );
};

export default CarouselLayout;
